/**
 * Editing quotation terms as plain text, without losing what the templates carry.
 *
 * `Quotation.terms` is HTML because the ERP's editor stores it that way. Nobody pricing a
 * quotation should have to type `<p>` tags to change a delivery clause, so the card edits text and
 * converts on save — but the live templates are not all plain: the Bahrain one is 3,024 characters
 * of numbered clauses with bold and underline, and a text round trip flattens every bit of it.
 *
 * This predicts that loss so the screen can warn BEFORE the edit, rather than leaving someone to
 * discover their formatting gone after saving.
 */

/**
 * Tags a plain-text round trip cannot survive.
 *
 * `<p>` and `<br>` are absent on purpose: `textToHtml` re-emits paragraphs and single newlines, so
 * they come back intact. `<div>` is absent too — the ERP wraps everything in
 * `<div class="ql-editor read-mode">`, and treating that as formatting would warn on every
 * template, which is the same as never warning at all.
 */
const RICH_TAGS = /<\s*(ol|ul|li|strong|b|u|em|i|table|tr|td|th|h[1-6]|img|a)\b/i

/** An inline `style` or `class` on anything other than the wrapper is authored formatting too. */
const INLINE_STYLE = /<(?!div\b)[a-z]+[^>]*\sstyle\s*=/i

export function hasRichFormatting(html: string | null | undefined): boolean {
  const text = html ?? ''
  if (text.trim() === '') return false
  return RICH_TAGS.test(text) || INLINE_STYLE.test(text)
}
